import type { ArchivedPostFragment, ArchivedPostTeaserFragment } from '$gen/graphql';
import gql from 'graphql-tag';

export const archivedPost = gql`
    fragment archivedPost on archivedPost_default_Entry {
        ... on archivedPost_default_Entry {
            __typename
            id
            title
            names
            exhibitionTitle
            subheadline
            locationNameArchiv
            linkToLocationArchive
            year: openingExhibition @formatDateTime(format: "Y")
            startDate: openingExhibition @formatDateTime(format: "d.m")
            endDate: endOfExhibition @formatDateTime(format: "d.m.Y")
            curatorArchive
            textAuthor
            photographer
            linkToVideo
            textArchive
            imagesArchive {
                ... on imagesArchive_image_BlockType {
                    __typename
                    id
                    image {
                        ... on archiveAssets_Asset {
                            __typename
                            id
                            url
                            title
                            width
                            height
                        }
                    }
                    caption
                }
            }
            seoImage: imagesArchive(limit: 1) {
                ... on imagesArchive_image_BlockType {
                    __typename
                    id
                    image @transform(width: 1200, height: 628) {
                        ... on archiveAssets_Asset {
                            __typename
                            id
                            url
                            title
                            width
                            height
                        }
                    }
                    caption
                }
            }
        }
    }
`;

export const isArchivedPost = (item): item is ArchivedPostFragment => {
    return (item as ArchivedPostFragment).__typename === 'archivedPost_default_Entry';
};

export const archivedPostTeaser = gql`
    fragment archivedPostTeaser on archivedPost_default_Entry {
        ... on archivedPost_default_Entry {
            __typename
            id
            slug
            title
            uri
            exhibitionTitle
            openingExhibition
            year: openingExhibition @formatDateTime(format: "Y")
            date: openingExhibition @formatDateTime(format: "d.m.y")
            endOfExhibition
            imagesArchive(limit: 1) {
                ... on imagesArchive_image_BlockType {
                    __typename
                    image {
                        ... on archiveAssets_Asset {
                            __typename
                            url
                            width
                            height
                        }
                    }
                }
            }
        }
    }
`;

export const isArchivedPostTeaser = (item): item is ArchivedPostTeaserFragment => {
    return (item as ArchivedPostTeaserFragment).__typename === 'archivedPost_default_Entry';
};
